import { SignIn, SignUp } from "@clerk/clerk-react";
import { Box, Button, Grid } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "schemas/routes";

import { LANDING_PAGE_LINK } from "constants/influencer";
import { AuthAction } from "features/Auth/schema";

interface Props {
  email?: string | null;
  action: AuthAction;
}

const InstagramOnboardingSignup = ({ email, action }: Props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const redirectUrl = `/${routes.onboardingInstagram}${location.search}`;
  const signInUrl = `/${routes.onboardingInstagram}/sign-in/${location.search}`;
  const signUpUrl = `/${routes.onboardingInstagram}/sign-up/${location.search}`;

  const handleBack = () => {
    navigate(`/${routes.preferencesInstagramOnboarding}${location.search}`);
  };
  return (
    <Grid
      container
      justifyContent={"center"}
      alignItems="center"
      sx={{ height: "100vh" }}
    >
      <Grid item xs={12}>
        <Button
          size="small"
          onClick={handleBack}
          sx={{ textTransform: "none" }}
        >
          <Box
            component="i"
            className="fa-regular fa-arrow-left"
            sx={{ mr: 1 }}
          />
          Back{" "}
        </Button>
      </Grid>
      {action === AuthAction.SIGN_UP && (
        <SignUp
          initialValues={{
            emailAddress: email || "",
          }}
          signInUrl={signInUrl}
          afterSignUpUrl={redirectUrl}
          afterSignInUrl={redirectUrl}
          appearance={{
            layout: {
              logoLinkUrl: LANDING_PAGE_LINK,
            },
          }}
        />
      )}
      {action === AuthAction.SIGN_IN && (
        <SignIn
          initialValues={{
            emailAddress: email || "",
          }}
          signUpUrl={signUpUrl}
          afterSignUpUrl={redirectUrl}
          afterSignInUrl={redirectUrl}
          appearance={{
            layout: {
              logoLinkUrl: LANDING_PAGE_LINK,
            },
          }}
        />
      )}
    </Grid>
  );
};

export default InstagramOnboardingSignup;
